import React from 'react';
import RepCoachingPlans from 'components/dashboard/rep/RepCoachingPlans';
import RepCallActivity from 'components/dashboard/rep/RepCallActivity';
import RepReviewActivities from 'components/dashboard/rep/RepReviewActivities';
import RepCoachingReceived from 'components/dashboard/rep/RepCoachingReceived';
import RepCalls from 'components/dashboard/rep/RepCalls';
import {RepProfileTab} from '@store/coaching-plans';
import '$pages/$rep-profile/RepProfilePage.styl';
import './RepProfilePage.styl';
import classnames from 'classnames';

/**
 * As the name suggested, this class takes its content from the other RepProfilePage under components/pure/metrics.
 * All it does is splitting the tabs into individual components, and each such component really
 * just collect the necessary props and then render a different component, so there is little risk of the original
 * being changed without this (and its children) getting out-of-sync. Also, metrics/RepProfilePage should go
 * away entirely once we move rep to dashv2 also (which should not be hard now since coach shares much with a rep,
 * in fact this component and its children are named RepXyz, because there is nothing coach-specific to them)
 */
export default class RepProfilePage extends React.Component {
  render() {
    const {page, managerId, adminId} = this.props;
    return (
      <div className="rep-profile-page dashv2">
        <div
          className={classnames('rep-profile-page-layout', adminId || managerId ? 'manager' : '')}>
          {page === RepProfileTab.COACHING_PLANS && (
            <RepCoachingPlans {...this.props} {...this.props.params} />
          )}
          {page === RepProfileTab.CALL_ACTIVITY && (
            <RepCallActivity {...this.props} {...this.props.params} />
          )}
          {page === RepProfileTab.REVIEW_ACTIVITIES && (
            <RepReviewActivities {...this.props} {...this.props.params} />
          )}
          {page === RepProfileTab.COACHING_RECEIVED && (
            <RepCoachingReceived {...this.props} {...this.props.params} />
          )}
          {page === RepProfileTab.CALLS && <RepCalls {...this.props} {...this.props.params} />}
        </div>
      </div>
    );
  }
}
